import { styled } from 'next-yak';

export const StyledLogo = styled.div<{ $size: number }>`
  cursor: pointer;
  height: ${({ $size }) => `${($size / 10)}rem`};
`;
